export const QuickBooksParent = {
  SALES: 'SALES',
  PURCHASES: 'PURCHASES',
  NONE: 'NONE',
}

export const quickBooksSalesParents = [
  QuickBooksParent.SALES,
]

export const quickBooksPurchasingParents = [
  QuickBooksParent.PURCHASES,
]

export const getQuickBooksInvoiceDeepLinkUrl = (baseURL, isCreditNote, accountingInvoiceId) => {
  return isCreditNote
      ? `${baseURL}/creditmemo?txnId=${accountingInvoiceId}`
      : `${baseURL}/invoice?txnId=${accountingInvoiceId}`
}

export const getQuickBooksBillDeepLinkUrl = (baseURL, isCreditNote, accountingInvoiceId) => {
  return isCreditNote
      ? `${baseURL}/vendorcredit?txnId=${accountingInvoiceId}`
      : `${baseURL}/bill?txnId=${accountingInvoiceId}`
}
